
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const PaymentRequired = lazy(() => import('../pages/PaymentRequired'));
const HoodExhaustCleaningPage = lazy(() => import('../pages/services/hood-exhaust-cleaning/page'));
const FanFilterMaintenancePage = lazy(() => import('../pages/services/fan-filter-maintenance/page'));
const DuctSystemCleaningPage = lazy(() => import('../pages/services/duct-system-cleaning/page'));
const FireSuppressionPage = lazy(() => import('../pages/services/fire-suppression/page'));
const PreOpeningCleanPage = lazy(() => import('../pages/services/pre-opening-clean/page'));
const EmergencyCleaningPage = lazy(() => import('../pages/services/emergency-cleaning/page'));

const routes: RouteObject[] = [
  // ⚠️ PAYMENT HOLD MODE: Swap comments below to restore the full site
  {
    path: '/',
    element: <PaymentRequired />, // ACTIVE: payment hold page
    // element: <HomePage />,    // RESTORE: uncomment this & comment above line to bring site back
  },
  {
    path: '/site-preview', // Hidden preview of full site (for internal use only)
    element: <HomePage />,
  },
  {
    path: '/services/hood-exhaust-cleaning',
    element: <HoodExhaustCleaningPage />,
  },
  {
    path: '/services/fan-filter-maintenance',
    element: <FanFilterMaintenancePage />,
  },
  {
    path: '/services/duct-system-cleaning',
    element: <DuctSystemCleaningPage />,
  },
  {
    path: '/services/fire-suppression',
    element: <FireSuppressionPage />,
  },
  {
    path: '/services/pre-opening-clean',
    element: <PreOpeningCleanPage />,
  },
  {
    path: '/services/emergency-cleaning',
    element: <EmergencyCleaningPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
